module.exports = __webpack_public_path__ + "static/media/8OLA30.42ec54f6.jpg";